import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, useMediaQuery } from '@mui/material';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { DialogActionButton } from 'components/Dialog';
import PreferPhotoDialog from 'containers/ManageDelivery/Dialog/PreferPhotoDialog';

import api from 'utils/api';
import { useStyles } from './styles';

const SelectPreferredPhoto = compose(
  inject('store'),
  observer,
)(({ store, closeDialog, setFinishUpFeedback }) => {
  const { deliveryStore, podStore } = store;
  const { delivery } = deliveryStore;
  const [imageList, setImageList] = useState(podStore.imagesPOD || []);
  const [idxSelectedImg, setIdxSelectedImg] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const { tracking_code } = useParams();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [isOpeningPreferredPhoto, setIsOpeningPreferredPhoto] = useState(false);

  const classes = useStyles();

  const handleSelectPreferred = (idx) => {
    if (idx === idxSelectedImg) {
      setIdxSelectedImg(-1);
      return;
    }
    setIdxSelectedImg(idx);
  };

  const updatePreferredPhoto = (url, payload) => {
    setIsLoading(true);
    api.post(url, payload).then((response) => {
      setIsLoading(false);
      if (response.status === 200) {
        setIdxSelectedImg(-1);
        setFinishUpFeedback(true);
      } else {
        setFinishUpFeedback(false);
      }
    });
  };

  const handleSubmit = () => {
    if (idxSelectedImg === -1) {
      setFinishUpFeedback(true);
      return;
    }
    const formData = new FormData();
    const findPhoto = imageList?.find((img, idx) => idx === idxSelectedImg);
    if (typeof findPhoto?.url === 'string') {
      updatePreferredPhoto(`delivery/${tracking_code}/${delivery.shipment.id}/update-profile`, { image_urls: [findPhoto?.url?.split('?')?.[0]] });
    } else {
      formData.append('image', findPhoto.url);
      updatePreferredPhoto(`delivery/${tracking_code}/${delivery.shipment.id}/update`, formData, { headers: { 'Content-Type': undefined } });
    }
  };

  const handleCancel = () => {
    setFinishUpFeedback(true);
    setIdxSelectedImg(-1);
    deliveryStore.updateField('isSubmittedFeedback', false);
  };

  const handlePreferredPhoto = () => {
    setIsOpeningPreferredPhoto(true);
    deliveryStore.updateField('isOpenPreferredPhoto', true);
  };

  return (
    <>
      {!isOpeningPreferredPhoto && (
        <Grid container spacing={3} justifyContent="center" sx={classes.gridContainer}>
          <Grid size={12} sx={classes.itemCenter}>
            <span>To help us improve, please select the photo that best matches your preferred dropoff location.</span>
          </Grid>
          <Grid size={12}>
            <Box display={'flex'} flexDirection={'row'} flexWrap="wrap" style={{ gap: '5px' }} justifyContent={'center'}>
              {imageList?.map((m, idx) => (
                <Box
                  component="img"
                  src={typeof m.url === 'string' ? m.url : URL.createObjectURL(m.url)}
                  key={`image-${idx}`}
                  sx={{
                    maxWidth: isMobile ? '30%' : '15%',
                    ...classes.imagePreferred,
                    ...(idx === idxSelectedImg && classes.selectImgPreferred),
                    ...(idx !== idxSelectedImg && idxSelectedImg !== -1 && classes.notSelectImgPreferred),
                  }}
                  onClick={() => handleSelectPreferred(idx)}
                  alt="dropoff"
                />
              ))}
            </Box>

            <Box textAlign={'center'} mt={4} mb={2}>
              or
            </Box>
            <Box display={'flex'} justifyContent={'center'}>
              <Button
                onClick={handlePreferredPhoto}
                variant="outlined"
                sx={{ ...classes.rootButton, ...classes.buttonLabel }}
                fullWidth={isMobile}
                color="inherit"
              >
                Upload My Preferred Dropoff Photo
              </Button>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: isMobile ? 'column' : 'row',
                gap: '10px',
                mt: 2,
                marginBottom: isMobile ? '10px' : 0,
              }}
            >
              <DialogActionButton onClick={handleCancel} variant="outlined" color="primary" disabled={isLoading}>
                Cancel
              </DialogActionButton>
              <DialogActionButton
                color="primary"
                variant="contained"
                style={{ marginLeft: 5 }}
                onClick={handleSubmit}
                disabled={isLoading || idxSelectedImg === -1}
              >
                {isLoading && <CircularProgress size={20} />}
                {!isLoading && 'Submit'}
              </DialogActionButton>
            </Box>
          </Grid>
        </Grid>
      )}
      {isOpeningPreferredPhoto && (
        <PreferPhotoDialog
          setFinishUpFeedback={(val) => setFinishUpFeedback(val)}
          setIsOpeningPreferredPhoto={(val) => setIsOpeningPreferredPhoto(val)}
        />
      )}
    </>
  );
});

export default SelectPreferredPhoto;
